if (!customElements.get('bundle-countdown-timer')) {
  class BundleCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.circumference = 2 * Math.PI * 32;
    }

    connectedCallback() {
      this.startTime = this.parseDate(this.dataset.startTime) || Date.now();
      this.endTime = this.parseDate(this.dataset.endTime);

      this.valueNodes = {
        day: this.querySelector('.countdown-timer-day'),
        hour: this.querySelector('.countdown-timer-hour'),
        min: this.querySelector('.countdown-timer-minute'),
        sec: this.querySelector('.countdown-timer-sec'),
      };

      this.rings = Array.from(this.querySelectorAll('.bct__ring')).map((ring) => ({
        unit: ring.dataset.unit,
        progress: ring.querySelector('[data-progress-ring]'),
      }));

      this.rings.forEach(({ progress }) => {
        if (!progress) return;
        progress.style.strokeDasharray = `${this.circumference}`;
        progress.style.strokeDashoffset = `${this.circumference}`;
      });

      this.totalDays = Math.max(
        1,
        Math.ceil((this.endTime - this.startTime) / (24 * 60 * 60 * 1000))
      );

      if (!this.endTime || Number.isNaN(this.endTime)) {
        return;
      }

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    parseDate(value) {
      if (!value) return null;
      const parsed = Date.parse(String(value).trim().replace(' ', 'T'));
      return Number.isNaN(parsed) ? null : parsed;
    }

    tick() {
      const remaining = Math.max(0, this.endTime - Date.now());
      const timeData = this.formatRemaining(remaining);

      this.setValue('day', timeData.day);
      this.setValue('hour', timeData.hour);
      this.setValue('min', timeData.min);
      this.setValue('sec', timeData.sec);
      this.updateRings(timeData);

      if (remaining <= 0) {
        this.handleComplete();
      }
    }

    setValue(unit, value) {
      const node = this.valueNodes[unit];
      if (node) node.textContent = this.pad(value);
    }

    formatRemaining(ms) {
      const day = Math.floor(ms / (24 * 60 * 60 * 1000));
      const hour = Math.floor((ms % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      const min = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
      const sec = Math.floor((ms % (60 * 1000)) / 1000);

      return { day, hour, min, sec };
    }

    pad(value) {
      return value < 10 ? `0${value}` : String(value);
    }

    updateRings(timeData) {
      const progressMap = {
        day: Math.min(1, timeData.day / this.totalDays),
        hour: timeData.hour / 24,
        min: timeData.min / 60,
        sec: timeData.sec / 60,
      };

      this.rings.forEach(({ unit, progress }) => {
        if (!progress) return;
        const fraction = progressMap[unit] ?? 0;
        progress.style.strokeDashoffset = `${this.circumference * (1 - fraction)}`;
      });
    }

    handleComplete() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }

      Object.keys(this.valueNodes).forEach((unit) => this.setValue(unit, 0));
      this.updateRings({ day: 0, hour: 0, min: 0, sec: 0 });
    }
  }

  customElements.define('bundle-countdown-timer', BundleCountdownTimer);
}
